import React, { useEffect, useState, useCallback } from "react";
import CountdownTimer from "react-component-countdown-timer";

const Countdown_Timer = (props) => {
  const [settings, setsettings] = useState({
    count: props.count,
    border: true,
    showTitle: true,
    noPoints: true,
  });

  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    setsettings({
      count: props.count,
      border: true,
      showTitle: true,
      noPoints: true,
    });
    
    let sessionTimer = setTimeout(() => {
      props.endTimer(props.count)
    }, props.count * 1000);
    // forceUpdate();
    return () => clearTimeout(sessionTimer);
    
  }, [props.count]);

  return (
    <div className="d-flex flex-row">
      <CountdownTimer
        responsive
        {...settings}
        size={50}
        hideDay
        hideHours
        showTitle
        border
        backgroundColor={props.color}
      />
    </div>
  );
};

export default Countdown_Timer;
